import Modal from 'react-bootstrap/Modal';

interface JobQuoteExtraTrolleyProps {
    showModal: boolean;
    trolley: boolean;
    isEpa: boolean;
    readOnly: boolean;
    update(trolley: boolean): void;
    hideModal(): void;
    saveModal(): void;
}

const JobQuoteExtraTrolleyData = (props: JobQuoteExtraTrolleyProps) => {
    
    const handleCheckboxChange = (e: any) => {
        props.update(e.target.checked);
    }

    const save = (e: any) => {
        e.preventDefault();

        props.saveModal();
    }

    return (
        <Modal show={props.showModal} onHide={props.hideModal} backdrop="static">
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Add {props.isEpa ? "Grease Trap" : "Trolley"} to Job</Modal.Title>
                <button type="button" className="close" onClick={props.hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <div>If a trolley is required for this job, tick the box below.</div>
                <label className="input-group" htmlFor="trolley">
                    <span className="label">Include {props.isEpa ? "Grease Trap" : "Trolley"}?</span>
                    <input className="checkbox" type="checkbox" id="trolley" name="trolley" checked={props.trolley} onChange={(e) => handleCheckboxChange(e)} disabled={props.readOnly}></input>
                </label>
            </Modal.Body>
            <Modal.Footer>
                <button className={props.readOnly ? "hidden" : "popup-button--yes"} onClick={save}>Calculate</button>
                <button className={props.readOnly ? "popup-button--yes" : "hidden"} onClick={props.hideModal}>Close</button>
            </Modal.Footer>
        </Modal>
    )
}

export default JobQuoteExtraTrolleyData;